var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13686_199539",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13686_199539)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5C11.1833 21.5 9.946 21.25 8.788 20.75C7.62933 20.25 6.625 19.575 5.775 18.725C4.925 17.875 4.25 16.8707 3.75 15.712C3.25 14.554 3 13.3167 3 12C3 10.6833 3.25 9.44567 3.75 8.287C4.25 7.129 4.925 6.125 5.775 5.275C6.625 4.425 7.62933 3.75 8.788 3.25C9.946 2.75 11.1833 2.5 12.5 2.5C13.55 2.5 14.546 2.65833 15.488 2.975C16.4293 3.29167 17.2917 3.73333 18.075 4.3L17 5.4C16.35 4.96667 15.6457 4.625 14.887 4.375C14.129 4.125 13.3333 4 12.5 4C10.2833 4 8.396 4.779 6.838 6.337C5.27933 7.89567 4.5 9.78333 4.5 12C4.5 14.2167 5.27933 16.1043 6.838 17.663C8.396 19.221 10.2833 20 12.5 20C14.7167 20 16.6043 19.221 18.163 17.663C19.721 16.1043 20.5 14.2167 20.5 12C20.5 11.65 20.475 11.304 20.425 10.962C20.375 10.6207 20.3083 10.2833 20.225 9.95L21.425 8.725C21.6083 9.24167 21.75 9.77067 21.85 10.312C21.95 10.854 22 11.4167 22 12C22 13.3167 21.75 14.554 21.25 15.712C20.75 16.8707 20.075 17.875 19.225 18.725C18.375 19.575 17.371 20.25 16.213 20.75C15.0543 21.25 13.8167 21.5 12.5 21.5ZM11.075 16.25L7.175 12.35L8.225 11.3L11.075 14.15L20.95 4.275L22 5.325L11.075 16.25Z",
    fill: "#00A79D"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIcon);
export default __webpack_public_path__ + "static/media/payment-success-icon.3049c76674bda9861fe85a6f05be8413.svg";
export { ForwardRef as ReactComponent };